import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import PageHeader from "../common/PageHeader";
import Loader from "../common/Loader";
import StatusPill from "../common/StatusPill";
import { getClosedMarketOrderById } from "../../api/closedMarket";
import { formatDeliveryWindow } from "../../utils/status";

export default function ClosedMarketOrderDetail() {
	const { orderId } = useParams();
	const [loading, setLoading] = useState(true);
	const [order, setOrder] = useState(null);

	useEffect(() => {
		(async () => {
			setLoading(true);
			const res = await getClosedMarketOrderById(orderId);
			if (res && !res.error) setOrder(res.data);
			setLoading(false);
		})();
	}, [orderId]);

	if (loading) return <Loader />;
	if (!order) return <div>Order not found.</div>;

	const products = order.sellerBidPriceDetail?.products || [];
	const totalPrice = products.reduce((sum, p) => sum + (p.wholePriceOfQuantity || 0) + (p.freightCharges || 0), 0);

	return (
		<div>
			<PageHeader
				title={`Closed Market Order ${order.orderId || orderId.slice(-6).toUpperCase()}`}
				subtitle={<StatusPill order={order} />}
			/>
			<div className="card p-4" style={{ maxWidth: 560 }}>
				<Row label="Location" value={order.locationDetails?.locationName} />
				<Row label="Product" value={(order.productType || []).map((p) => p.Title).join(", ")} />
				<Row label="Order size" value={order.orderSize ? `${order.orderSize} gal` : "-"} />
				<Row label="Total price" value={totalPrice ? `$${totalPrice.toFixed(2)}` : "-"} />
				<Row label="Placed" value={order.createdAt ? moment(order.createdAt).format("MMM D, YYYY h:mm A") : "-"} />
				<Row label="Delivery date" value={order.deliveryDate ? moment(order.deliveryDate).format("MMM D, YYYY") : "-"} />
				<Row label="Delivery window" value={formatDeliveryWindow(order.deliveryTime)} />
			</div>
			{products.length > 0 && (
				<div className="card p-4 mt-3" style={{ maxWidth: 560 }}>
					<h6 className="fw-bold mb-3">Product Breakdown</h6>
					{products.map((p, idx) => (
						<Row
							key={idx}
							label={`${p.quantity || 0} gal @ $${p.bidPricePerGallon ?? "-"}/gal`}
							value={p.wholePriceOfQuantity ? `$${p.wholePriceOfQuantity.toFixed(2)}` : "-"}
						/>
					))}
				</div>
			)}
		</div>
	);
}

function Row({ label, value }) {
	return (
		<div className="d-flex justify-content-between border-bottom py-2">
			<span className="text-muted">{label}</span>
			<span className="fw-semibold">{value || "-"}</span>
		</div>
	);
}
